import React from 'react';
import { motion } from 'framer-motion';
import { Flag } from 'lucide-react';
interface CheckpointFlagProps {
  label: string;
  emoji: string;
  align: 'left' | 'right';
}
export function CheckpointFlag({
  label,
  emoji,
  align
}: CheckpointFlagProps) {
  const alignClass = align === 'left' ? 'self-start ml-2 sm:ml-8' : 'self-end mr-2 sm:mr-8';
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} className={`flex items-center gap-2 relative z-10 my-2 ${alignClass}`} data-id="element-1752">
      {align === 'right' && <div className="bg-white/90 backdrop-blur-sm border-2 border-slate-200 px-3 py-1.5 rounded-xl shadow-sm text-xs font-bold text-slate-600 max-w-[140px] text-right" data-id="element-1753">
          {label}
        </div>}

      <div className="relative" data-id="element-1754">
        <div className="w-1 h-12 bg-slate-300 rounded-full absolute left-1/2 -translate-x-1/2 bottom-0" data-id="element-1755" />
        <div className="w-10 h-10 bg-amber-100 border-2 border-amber-300 rounded-full flex items-center justify-center shadow-sm relative z-10 text-lg" data-id="element-1756">
          {emoji}
        </div>
      </div>

      {align === 'left' && <div className="bg-white/90 backdrop-blur-sm border-2 border-slate-200 px-3 py-1.5 rounded-xl shadow-sm text-xs font-bold text-slate-600 max-w-[140px] text-left" data-id="element-1757">
          {label}
        </div>}
    </motion.div>;
}